import { useApiQuery } from 'theSource/utils';
import { EnrollmentContextResponseDto } from './types';
import {
  GET_ENROLLMENT_CONTEXT_QUERY_KEY,
  ENROLLMENT_CONTEXT_ENDPOINT,
} from './utils';
import { useConfigurationQuery } from '../useConfigurationQuery/useConfigurationQuery';

export interface UseEnrollmentContextQueryProps {
  enabled: boolean;
  apiHost?: string;
}

export const useEnrollmentContextQuery = ({
  enabled,
}: UseEnrollmentContextQueryProps) => {
  const { configuration } = useConfigurationQuery();
  const lumosApiHost = configuration?.apiHost;
  const {
    data: enrollmentContext,
    isLoading: isLoadingEnrollmentContext,
    isFetching: isFetchingEnrollmentContext,
  } = useApiQuery<EnrollmentContextResponseDto, unknown>({
    queryKey: GET_ENROLLMENT_CONTEXT_QUERY_KEY,
    endpoint: ENROLLMENT_CONTEXT_ENDPOINT,
    showErrorSnackbar: false,
    enabled,
    config: {
      baseURL: `${lumosApiHost}/v2/self_service`,
    },
    params: {
      include_enrollment_status: true,
    },
  });

  return {
    enrollmentContext,
    isLoadingEnrollmentContext,
    isFetchingEnrollmentContext,
  };
};
